import { createSelector } from '@reduxjs/toolkit';
import selectCommonRaw from './selectCommonRaw';
import selectIsOnline from './selectIsOnline';

export default createSelector(selectCommonRaw, selectIsOnline, ({ online: on, offline: off }, online) => ({
  online,
  start: online ? on : off,
  prev: {
    start: online ? off : on,
    duration: online ? on - off : off - on,
  },
}));
